import { useNavigate } from '@reach/router';
import { useEffect, useMemo, useState } from 'react';

import { useGetStaticList } from '../../core/APIHooks/static';
import { ROUTES } from '../../pages/routes';
import StaticPageById from './StaticPageById';
import StaticPageLoader from './StaticPageLoader';

export type StaticPageProps = {
  page: string;
};

const StaticPage = ({ page }: StaticPageProps) => {
  const navigate = useNavigate();
  const [staticPageId, setStaticPageId] = useState<number>();
  const { data: pages, isLoading, isError } = useGetStaticList();

  useEffect(() => {
    if (!isLoading && !isError && page) {
      const filteredPages = pages?.filter((item) => item.slug === page);
      if (filteredPages && filteredPages.length > 0) {
        setStaticPageId(filteredPages[0].id);
      } else {
        navigate(ROUTES.NOTFOUND);
      }
    }
  }, [isLoading, isError, page, pages, setStaticPageId, navigate]);

  return useMemo(() => {
    if (isError) {
      navigate(ROUTES.NOTFOUND);
      return null;
    }

    if (isLoading || !staticPageId) return <StaticPageLoader />;

    return <StaticPageById id={staticPageId} />;
  }, [isError, isLoading, navigate, staticPageId]);
};

export default StaticPage;
